import { createMachine, assign } from "xstate";
import { fetchApi } from "../../tools";
import { log } from "xstate/lib/actions";
const fetchData = async (urlCursos, headers, idCurso, idSede) => {
  const response = await fetchApi({
    url: urlCursos + "/utils/busquedas",
    headers: headers,
    content: {
      Opcion: "CURSOS",
      IdCatalogo: idCurso,
      IdSede: idSede,
    },
  });
};

//esta función va ir importado desde un archivo o carpeta llamada api

const centroMachine = createMachine(
  {
    id: "centro",
    initial: "BusquedaAlumCursos", // paso 1
    context: {
      monto: 0,
      datos: [],
      seleccionados: [],
      catalogos: [],
      datosUsuario: {},
      headers: undefined,
      IdEmp: "",
      modalidad: null,
      idCurso: undefined,
      sede: "",
      solicitud: 0,
      idCursoD: [],
      opcion: 0,
      carnet: "",
      nombreSede: "",
      total: 0,
      cursos: undefined,
      CursosAntes: undefined,
      formaspago: [],
      pasos: [
        { id: 1, name: "INGRESO DE DATOS", href: "", status: "current" },
        { id: 2, name: "ASIGNACIÓN", href: "", status: "upcoming" },
        { id: 3, name: "PAGO", href: "", status: "upcoming" },
      ],
      cursos: [],
      sedes: [],
      pasosPagos: [
        { id: 1, name: "SELECCIÓN DE ALUMNO", href: "", status: "current" },
        { id: 2, name: "ASIGNACIÓN", href: "", status: "upcoming" },
        { id: 3, name: "PAGO", href: "", status: "upcoming" },
      ],
    },
    states: {
      BusquedaAlumCursos: {
        entry: assign(
          (context, event) =>
          (context.pasos = [
            { id: 1, name: "INGRESO DE DATOS", href: "", status: "current" },
            { id: 2, name: "ASIGNACIÓN", href: "", status: "upcoming" },
            { id: 3, name: "PAGO", href: "", status: "upcoming" },
          ],
            context.pasosPagos = [
              { id: 1, name: "SELECCIÓN DE ALUMNO", href: "", status: "current" },
              { id: 2, name: "ASIGNACIÓN", href: "", status: "upcoming" },
              { id: 3, name: "PAGO", href: "", status: "upcoming" },
            ]
          )
        ),
        /*
          invoke: { // hace la llamada para cargar la data al cargar el componente
            id: "getData",
            src: () => fetchData,
            onDone:{
              actions: assign({
                datos: (context, event) => event.data
              })
            },
          },*/
        on: {
          ACEPTAR: {
            target: "Paso2",
            actions: assign({
              solicitud: (context, event) => event.solicitud
            })
          },
          IR_PASO2: {
            target: "Paso2",
          },
          GUARDAR_MODALIDAD: {
            actions: assign((context, event) => context.datosUsuario.Modalidad = event.modalidad
            )
          },
          GUARDAR_IDSOLICITUD_TRASLADO: {
            target: "TrasladoCursos",
            actions: assign((context, event) => context.solicitud = event.solicitud
            )
          },
          GUARDAR_IDSOLICITUD: {
            target: "Paso2",
            actions: assign((context, event) => context.solicitud = event.solicitud
            )
          },
          GUARDAR_IDSOLICITUD_TRASLADO: {
            target: "TrasladoCursos",
            actions: assign((context, event) => context.solicitud = event.solicitud
            )
          },
          GUARDAR_CURSOS_ANTES: {
            actions: assign((context, event) => context.CursosAntes = event.CursosAntes
            )
          },
          GUARDAR_CARNET: {
            actions: assign((context, event) => context.carnet = event.carnet)
          },
          GUARDAR_FORMASPAGO: {
            actions: assign({
              formaspago: (context, event) => event.formasp
            })
          },
          GUARDAR_CURSOS: {
            actions: assign((context, event) => context.cursos = event.cursos
            )
          },
          RESET_SELECCIONADOS: {
            actions: assign({
              seleccionados: (context, event) => event.reset
            })
          },

          SELECCIONAR: {
            //target: "Paso2",
            actions: assign((context, event) => {
              
              // const existente = (element) => element.Key===event.seleccionado.Key
              // if(!context.seleccionados.some(existente)){


              let b = new Set(context.seleccionados)
              b.add(event.seleccionado);
              context.seleccionados = [...b]
              context.seleccionados.sort(function (c, d) {
                if (c.sortIndex < d.sortIndex) {
                  return -1;
                }
                else if (c.sortIndex > d.sortIndex) {
                  return 1;
                }
                else {
                  if (c.Orden < d.Orden) {
                    return -1;
                  }
                  else if (c.Orden > d.Orden) {
                    return 1;
                  }
                  return 0;
                }
              })
              
            }

              // }
            ),
          },
          GUARDAR_HEADERS: {
            actions: assign({
              headers: (context, event) => event.headers
            })
          },
          GUARDAR_IDEMP: {
            actions: assign({
              IdEmp: (context, event) => event.IdEmp
            })
          },
          CARGAR_CATALOGOS: {

            actions: assign((context, event) => {
              context.catalogos = event.catalogos;
            }
            ),
          },
          GUARDAR_SEDE: {
            actions: assign((context, event) => context.sede = event.sede
            )
          },
          GUARDAR_DATOS_USUARIO: {
            actions: assign({
              datosUsuario: (context, event) => event.datosUsuario,
            }),
          },
          SET_ASIGNADOS: {
            target: "Paso2",
            actions: assign({
              seleccionados: (context, event) => event.asignados
            })
          },
          CANCELAR: {
            target: "Paso1",
            actions: console.log('CANCALAAR desde machine')
          },
          AVANZAR: {
            target: "Paso2",
            actions: console.log('CANCALAAR desde machine')
          },
        },
      },
      Paso1: {
        entry: assign(
          (context, event) =>
          (context.pasos = [
            { id: 1, name: "INGRESO DE DATOS", href: "", status: "current" },
            { id: 2, name: "ASIGNACIÓN", href: "", status: "upcoming" },
            { id: 3, name: "PAGO", href: "", status: "upcoming" },
          ],
            context.pasosPagos = [
              { id: 1, name: "SELECCIÓN DE ALUMNO", href: "", status: "current" },
              { id: 2, name: "ASIGNACIÓN", href: "", status: "upcoming" },
              { id: 3, name: "PAGO", href: "", status: "upcoming" },
            ]
          )
        ),
        /*
          invoke: { // hace la llamada para cargar la data al cargar el componente
            id: "getData",
            src: () => fetchData,
            onDone:{
              actions: assign({
                datos: (context, event) => event.data
              })
            },
          },*/
        on: {
          ACEPTAR: {
            target: "Paso2",
            actions: assign({
              solicitud: (context, event) => event.solicitud
            })
          },
          IR_PASO2: {
            target: "Paso2",
          },
          GUARDAR_IDSOLICITUD: {
            target: "Paso2",
            actions: assign((context, event) => context.solicitud = event.solicitud
            )
          },
          GUARDAR_CARNET: {
            actions: assign((context, event) => context.carnet = event.carnet)
          },
          GUARDAR_FORMASPAGO: {
            actions: assign({
              formaspago: (context, event) => event.formasp
            })
          },
          RESET_SELECCIONADOS: {
            actions: assign({
              seleccionados: (context, event) => event.reset
            })
          },
          SELECCIONAR: {
            //target: "Paso2",
            actions: assign((context, event) => {
              // const existente = (element) => element.Key===event.seleccionado.Key
              // if(!context.seleccionados.some(existente)){


              let b = new Set(context.seleccionados)
              b.add(event.seleccionado);
              context.seleccionados = [...b]
              context.seleccionados.sort(function (c, d) {
                if (c.sortIndex < d.sortIndex) {
                  return -1;
                }
                else if (c.sortIndex > d.sortIndex) {
                  return 1;
                }
                else {
                  if (c.Orden < d.Orden) {
                    return -1;
                  }
                  else if (c.Orden > d.Orden) {
                    return 1;
                  }
                  return 0;
                }
              })
            }
              // }
            ),
          },
          GUARDAR_HEADERS: {
            actions: assign({
              headers: (context, event) => event.headers
            })
          },
          GUARDAR_IDEMP: {
            actions: assign({
              IdEmp: (context, event) => event.IdEmp
            })
          },
          CARGAR_CATALOGOS: {
            actions: assign((context, event) => context.catalogos = event.catalogos,
            ),
          },
          GUARDAR_SEDE: {
            target: "Paso2",
            actions: assign((context, event) => context.sede = event.sede
            )
          },
          GUARDAR_DATOS_USUARIO: {
            actions: assign({
              datosUsuario: (context, event) => event.datosUsuario,
            }),
          },
          SET_ASIGNADOS: {
            target: "Paso2",
            actions: assign({
              seleccionados: (context, event) => event.asignados
            })
          },
          CANCELAR: {
            target: "Paso1",
            actions: console.log('CANCALAAR desde machine')
          },
          AVANZAR: {
            target: "Paso2",
            actions: console.log('CANCALAAR desde machine')
          },
        },
      },

      Paso2: {
        entry: assign(
          (context, event) =>
          (context.pasos = [
            { id: 1, name: "INGRESO DE DATOS", href: "", status: "complete" },
            { id: 2, name: "ASIGNACIÓN", href: "", status: "current" },
            { id: 3, name: "PAGO", href: "", status: "upcoming" },
          ],
            context.pasosPagos = [
              { id: 1, name: "SELECCIÓN DE ALUMNO", href: "", status: "complete" },
              { id: 2, name: "ASIGNACIÓN", href: "", status: "current" },
              { id: 3, name: "PAGO", href: "", status: "upcoming" },
            ]
          )
        ),
        on: {
          ACEPTAR: {
            target: "Paso3",
            actions: assign((context, event) => {
              context.total = event.total;
            }),
          },
          ACEPTAR_TRASLADO_FONDOS: {
            target: "BusquedaAlumCursos",
            actions: assign((context, event) => {
              context.total = event.total;
            }),
          },
          ABRIR: {
            target: "Cursos",
            actions: assign((context, event) => {
              context.headers = event.headers;
              context.idCurso = event.idCurso;
              context.sede = event.sede;
            }),
          },
          GUARDAR_CURSOS: {
            actions: assign((context, event) => context.cursos = event.cursos
            )
          },
          GUARDAR_SEDE: {
            target: "Paso2",
            actions: assign((context, event) => context.sede = event.sede
            )
          },
          GUARDAR_IDSOLICITUD: {
            target: "Paso2",
            actions: assign((context, event) => context.solicitud = event.solicitud
            )
          },
          GUARDAR_CARNET: {
            actions: assign((context, event) => context.carnet = event.carnet)
          },
          GUARDAR_NOMBRESEDE: {
            actions: assign(
              (context, event) => context.solicitud = event.nombreSede,
            ),
          },
          RESET_SELECCIONADOS: {
            actions: assign({
              seleccionados: (context, event) => event.reset
            })
          },
                   SELECCIONAR: {
            target: "Paso2",
            actions: assign((context, event) => {
              // const existente = (element) => element.Key===event.seleccionado.Key

              // console.log('CONTENIDO DE B:', b)
              //    b.add(event.seleccionado);

              // codigo para la edicion Pagar: 1
              // b.add(event.seleccionado);

              //context.seleccionados = context.seleccionados
              event.seleccionado.sort(function (c, d) {
                if (c.IdCargo < d.IdCargo) {
                  return -1;
                }
                else if (c.IdCargo > d.IdCargo) {
                  return 1;
                }
                else {
                  if (c.Orden < d.Orden) // yano filtra por sortIndex
                  {
                    return -1;
                  }
                  else if (c.Orden > d.Orden) {
                    return 1;
                  }
                  return 0;
                }
              })
              context.seleccionados = event.seleccionado
              // console.log('context.seleccionados: ', context.seleccionados)
            }
              // }
            ),
          },
          CARGAR_SEDES: {
            target: "Paso2",
            actions: assign((context, event) => (context.sedes = event.sedes)),
          },
          ACTUALIZAR_SELECCIONADOS: {
            actions: assign((context, event) => {
              context.seleccionados = event.seleccionados
            })
          },
          CARGAR_CURSOS: {
            actions: assign({
              cursos: (context, event) => event.cursos,
            }),
          },
          QUITAR_DE_DATOS: {
            target: "Paso2",
            actions: assign((context, event) => {
              context.datos = context.datos.filter(
                (elemento) => elemento.name !== event.seleccionado.name
              );
            }),
          },
          QUITAR: {
            actions: assign((context, event) => {

              // cambiar este codigo apara e solo cambi e estados
              context.seleccionados = event.quitar

            }),
          },
          QUITAR_DE_RESUMEN: { // ahora , cambia de estado el que se envía, Pagar  1
            actions: assign((context, event) => context.seleccionados = event.seleccionados)
            // context.datos.push(context.seleccionados[event.quitar])

          },
          CANCELAR: "Paso1",
          CANCELAR_2: "BusquedaAlumCursos",
          CANCELAR_3: "TrasladoCursos"
        },
      },
      TrasladoCursos: {
        entry: assign(
          (context, event) =>
          (context.pasos = [
            { id: 1, name: "INGRESO DE DATOS", href: "", status: "complete" },
            { id: 2, name: "ASIGNACIÓN", href: "", status: "current" },
            { id: 3, name: "PAGO", href: "", status: "upcoming" },
          ],
            context.pasosPagos = [
              { id: 1, name: "SELECCIÓN DE ALUMNO", href: "", status: "complete" },
              { id: 2, name: "ASIGNACIÓN", href: "", status: "current" },
              { id: 3, name: "PAGO", href: "", status: "upcoming" },
            ]
          )
        ),
        on: {
          ACEPTAR: {
            target: "Paso3",
            actions: assign((context, event) => {
              context.total = event.total;
            }),
          },
          ABRIR: {
            target: "Cursos",
            actions: assign((context, event) => {
              context.headers = event.headers;
              context.idCurso = event.idCurso;
              context.sede = event.sede;
            }),
          },
          GUARDAR_CURSOS: {
            actions: assign((context, event) => context.cursos = event.cursos
            )
          },
          RESET_CURSOS_ANTES: {
            actions: assign({
              CursosAntes: (context, event) => event.reset
            })
          },
          GUARDAR_CURSOS_ANTES: {
            actions: assign((context, event) => context.CursosAntes = event.CursosAntes
            )
          },
          GUARDAR_SEDE: {
            target: "TrasladoCursos",
            actions: assign((context, event) => context.sede = event.sede
            )
          },
          GUARDAR_IDSOLICITUD: {
            target: "TrasladoCursos",
            actions: assign((context, event) => context.solicitud = event.solicitud
            )
          },
          GUARDAR_CARNET: {
            actions: assign((context, event) => context.carnet = event.carnet)
          },
          GUARDAR_IDCURSOD: {
            target: "Paso2",
            actions: assign({
              idCursoD: (context, event) => event.idCursoD,
            }),
          },
          GUARDAR_OPCION_TRASLADO: {
            actions: assign((context, event) => context.opcion = event.opcion
            )
          },
          GUARDAR_NOMBRESEDE: {
            actions: assign(
              (context, event) => context.solicitud = event.nombreSede,
            ),
          },
          RESET_SELECCIONADOS: {
            actions: assign({
              seleccionados: (context, event) => event.reset
            })
          },
          SELECCIONAR: {
            target: "TrasladoCursos",
            actions: assign((context, event) => {
              // const existente = (element) => element.Key===event.seleccionado.Key
              // if(!context.seleccionados.some(existente)){
              let b = new Set(context.seleccionados)
              
              if (!context.seleccionados.some(elemento => elemento.IdCargo + elemento.Orden === event.seleccionado.IdCargo + event.seleccionado.Orden)) {
                b.add(event.seleccionado);
              } else {
                
              }
              context.seleccionados = [...b]
              context.seleccionados.sort(function (c, d) {
                if (c.IdCargo < d.IdCargo) {
                  return -1;
                }
                else if (c.IdCargo > d.IdCargo) {
                  return 1;
                }
                else {
                  if (c.Orden < d.Orden) // yano filtra por sortIndex
                  {
                    return -1;
                  }
                  else if (c.Orden > d.Orden) {
                    return 1;
                  }
                  return 0;
                }
              })
            }
              // }
            ),
          },
          CARGAR_SEDES: {
            target: "TrasladoCursos",
            actions: assign((context, event) => (context.sedes = event.sedes)),
          },
          ACTUALIZAR_SELECCIONADOS: {
            actions: assign((context, event) => {
              context.seleccionados = event.seleccionados
            })
          },
          CARGAR_CURSOS: {
            actions: assign({
              cursos: (context, event) => event.cursos,
            }),
          },
          QUITAR_DE_DATOS: {
            target: "TrasladoCursos",
            actions: assign((context, event) => {
              context.datos = context.datos.filter(
                (elemento) => elemento.name !== event.seleccionado.name
              );
            }),
          },
          QUITAR: {
            actions: assign((context, event) => {

              // context.seleccionados = context.seleccionados.filter(  elemento => ( (elemento.Cargo + elemento.Key + elemento.De)  !== (event.quitar.Cargo + event.quitar.Key + event.quitar.De)))
              // context.seleccionados = context.seleccionados.filter( elemento => ( (elemento.IdSede + elemento.Cargo + (elemento.Key + (typeof(elemento.IdSede) === "string"?parseInt(elemento.IdSede):elemento.IdSede)))  !== (event.quitar.IdSede + event.quitar.Cargo + (event.quitar.Key + (typeof(event.quitar.IdSede) === "string"?parseInt(event.quitar.IdSede):event.quitar.IdSede)))));
              context.seleccionados = context.seleccionados.filter(elemento => ((elemento.IdSede + elemento.Cargo + (elemento.Key + elemento.IdSede)) !== (event.quitar.IdSede + event.quitar.Cargo + (event.quitar.Key + event.quitar.IdSede))));
            }),
          },
          QUITAR_DE_RESUMEN: { // ahora , cambia de estado el que se envía, Pagar  1
            actions: assign((context, event) =>
            // context.datos.push(context.seleccionados[event.quitar])
            {
              // context.seleccionados = context.seleccionados.filter( elemento => ( (elemento.Cargo + elemento.Key + elemento.De)  !== (event.seleccionado.Cargo + event.seleccionado.Key + event.seleccionado.De)))
              context.seleccionados = context.seleccionados.filter(elemento => ((elemento.Cargo + elemento.Key) !== (event.seleccionado.Cargo + event.seleccionado.Key)))
            }
            ),
          },
          CANCELAR: "Paso1",
          CANCELAR_2: "BusquedaAlumCursos",
          CANCELAR_3: "TrasladoCursos"
        },
      },
      Cursos: {
        entry: {},
        on: {
          CANCELAR: {
            target: "Paso2",
          },
        },
      },
      Paso3: {
        entry: assign(
          (context, event) =>
          (context.pasos = [
            { id: 1, name: "INGRESO DE DATOS", href: "", status: "complete" },
            { id: 2, name: "ASIGNACIÓN", href: "", status: "complete" },
            { id: 3, name: "PAGO", href: "", status: "current" },
          ])
        ),
        on: {
          PAGAR: {
            target: "Paso1",
            actions: "imprimirCursos",
          },
          CANCELAR: {
            target: "Paso2",
          },
        },
      },
      success: {},
    },
  },
  {
    actions: {
      getData: () => console.log("GETTING DATA..."),
      imprimirPagado: () => {
        centroMachine.context.pasos = [
          { id: 1, name: "INGRESO DE DATOS", href: "", status: "complete" },
          { id: 2, name: "ASIGNACIÓN", href: "", status: "current" },
          { id: 3, name: "PAGO", href: "", status: "upcoming" },
        ];
      },
      imprimirCursos: () => console.log("context: ", centroMachine.context),
      seleccionarCurso: () => { },
    },
  }
);

export default centroMachine;
